<script>
export default {
  data() {
    return {
      seeGroup: false,
      brandList: false
    };
  },
  props: {
    group: null,
  },
  computed: {
    brands() {
      return this.$store.state.brands;
    },
  },
  methods: {
    close() {
      setTimeout(() => (this.seeGroup = false), 500);
    },
  },
};
</script>

<template>
  <section id="vagas" class="job">
    <div class="container job__box">
      <div class="d-flex flex-wrap flex-lg-nowrap w-100">
        <div class="job__box__card" :class="{disabled:brandList}">
          <div class="bg bg1"></div>
          <div class="text">
            <h3>
              Vagas <br />
              Corporativas
            </h3>
            <button
              @click="$router.push({name:'jobs.group',params:{group:'corporativas'}})"
              @blur="close()"
              class="btn--job"
            >
              VER OPORTUNIDADES
            </button>
          </div>
        </div>
        <div class="job__box__card">
          <div class="bg bg2"></div>
          <div class="text">
            <h3>
              Vagas <br />
              Em Lojas
            </h3>
            <button
               @click="$router.push({name:'jobs.group',params:{group:'lojas'}})"
              class="btn--job"
            >
              VER OPORTUNIDADES
            </button>
          </div>
        </div>
        <div class="job__box__card" :class="{disabled:brandList}">
          <div class="bg bg3"></div>
          <div class="text">
            <h3>
              Vagas nas Indústrias e <br />
              nos Centros Logísticos
            </h3>
            <button
            @click="
                $router.push({
                  name: 'jobs.group',
                  params: { group: 'industria' },
                })
              "
              class="btn--job"
            >
              VER OPORTUNIDADES
            </button>
          </div>
        </div>
      </div>
    </div>
    <section class="container job__team">
      <header>
        <h2>SOMOS UM TIME DE APAIXONADOS</h2>
        <p>
          Contamos com um time de realizadores que concretizam o sonho dos
          nossos clientes.
        </p>
        <p>
          Estamos entre as maiores varejistas de moda de alto padrão do Brasil ♥
          Com cinco marcas, duas indústrias, dois centros logísticos, escritório,
          cerca de 250 lojas, presença em mais de mil multimarcas pelo Brasil, a
          Restoque conta com presença digital e serviços completos para o
          consumidor.
        </p>
        <p>
          Não somos apenas uma marca de roupas ou lojas. Muito mais que isso,
          somos um estilo de vida, uma experiência única, um sentimento de
          bem-estar, realização, felicidade, inspiração, beleza; um sonho bom.
        </p>
      </header>
    </section>
    <section class="job__videos">
      <div class="container">
        <div class="row px-md-2">
          <div class="col-lg-6 px-md-2">
            <div class="job__videos__content">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/Lnubglm0OfM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
          <div class="col-lg-6 px-md-2">
            <div class="job__videos__content">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/0AKc4-Mo7wQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<style lang="scss" scoped src="../styles/job.scss">
  /deep/li{
      list-style: disc;
    }
</style>